import { AppBar, Toolbar } from '@mui/material'
import { observer } from 'mobx-react-lite'

import { IAcDefaultLayout } from '@layouts'

import { ReactComponent as BuurtboerLogo } from '@assets/logos/buurtboer-logo-horizontal.svg'
import { AcBox, AcCustomerSettings, AcMenuItem } from '@components'
import { useBreakpoints, useRoleToggle } from '@hooks'

export interface IAcNavbar {
  variant: IAcDefaultLayout['variant']
}

export const AcNavbar = observer(({ variant }: IAcNavbar) => {
  const { isMobile } = useBreakpoints()
  const { navigation } = useRoleToggle()

  return (
    <AppBar color={variant === 'branded' ? 'transparent' : 'green'}>
      <AcBox
        ml={5}
        mr={5}>
        <Toolbar disableGutters>
          <BuurtboerLogo />
          {!isMobile && (
            <AcBox
              ml={6}
              sx={{ flexGrow: 1, display: 'flex' }}>
              {navigation.map(page => (
                <AcMenuItem {...page} />
              ))}
            </AcBox>
          )}
          <AcCustomerSettings />
        </Toolbar>
      </AcBox>
    </AppBar>
  )
})
